<!--template html-->
<template>
    <div v-if="isSaving" class="gt-groupcard-loader">
        <img :src="$getAssetUrlPlugin('siteres/gt-loader.gif')" alt="Loading" />
        <p>
            Generating image preview
        </p>
    </div>
    <!-- Loader -->
    <div id="cropdivCover" class="popupDiv" style="top:5%;">
        <div style="display: none;">
            <input id="xC" name="xC" style="width: 60px;" />
            <input id="yC" name="yC" style="width: 60px;" />
            <input id="x2C" name="x2C" style="width: 60px;" />
            <input id="y2C" name="y2C" style="width: 60px;" />
            <input id="wC" name="wC" style="width: 60px;" />
            <input id="hC" name="hC" style="width: 60px;" />
        </div>
        <input type="hidden" id="path" value="false" />
        <div id="imageareaCover">
        </div>
        <div id="controls_croppie">
            <input type="image" src="https://grouptogether.blob.core.windows.net/images/btn_crop_ok.png" @click="submitImageCover" />
            <div style="width: 10px; height: 10px; display: block; float: left;"></div>
            <input type="image" id="cropbutton" src="https://grouptogether.blob.core.windows.net/images/btn_crop_cancel.png" @click="fadeOutCover" />
        </div>
    </div>
    <!-- Crop Div -->
</template>
<!--template html-->
<!--script -->
<script>
    import { boolean } from "yup/lib/locale"


    export default {
        name: 'GroupCardImageCrop',
        components: {
        },
        props: {
            collection: String
        },
        data: function () {
            return {
                isSaving: false,
                croppi: null
            }
        },
        mounted: function () {
        },
        methods: {
            fadeOutCover() {
                $('#cropdivCover').fadeOut()
                $(".modalOverlayTemplate").remove()
            },
            async submitImageCover() {
                this.isSaving = true
                var that = this
                var url = $("#imageurlCover").val()
                $("#imagepathCover").val(url)
                var x = Math.round($('#xC').val())
                var y = Math.round($('#yC').val())
                var x2 = Math.round($('#x2C').val())
                var y2 = Math.round($('#y2C').val())
                var w = Math.round($('#wC').val())
                var h = Math.round($('#hC').val())
                var targetWidth = w
                var targetHeight = h
                // This means the browser supports async file uploads.
                if (window.FormData) {
                    var formdata = new FormData()
                    var fileCover;
                    if ($("#path").val() == "false") {
                        fileCover = $("._image_upload_input_").prop("files")[0]
                    }
                    else {
                        fileCover = $("#file").prop("files")[0];
                    }
                    formdata.append("x", x)
                    formdata.append("y", y)
                    formdata.append("x2", x2)
                    formdata.append("y2", y2)
                    formdata.append("w", targetWidth)
                    formdata.append("h", targetHeight)
                    formdata.append("image", fileCover)
                    formdata.append("collection", this.collection)
                    //ajax call to create image
                   await $.ajax({
                        url: '/image/TransformImageGroupCardMessage',
                        type: "POST",
                        data: formdata,
                        processData: false,
                        contentType: false,
                        success: function (data) {
                            that.isSaving = false
                            that.fadeOutCover()
                            if ($("#path").val() == "false") {
                                $("._image_upload_img_").attr("src", data)
                            }
                            else {
                                that.$emit("uploadedImageUrls", data);
                                $(".dropdown-menu card-message").addClass("open show");
                            }
                            $("#file").val(null);
                        },
                        error: function () {
                            that.isSaving = false
                            console.log("Error has occurred.")
                        }
                    })
                }

            }

        }
    }
</script>
<!--script -->
<!--Add "scoped" attribute to limit CSS to this component only-->
<style scoped>
    .gt-groupcard-loader {
        z-index: 100000001;
    }
</style>